export default "__VITE_ASSET__yQNCCx_6__"